import { cva } from 'class-variance-authority';

import { cn } from '@/lib/cn';

export const buttonVariants = cva(
  cn(
    'inline-flex items-center justify-center gap-2 rounded font-medium',
    'transition-motion disabled:pointer-events-none disabled:opacity-50',
    // Focus is never removed and never replaced by a colour change alone (§4 Focus, §9).
    //
    // ⚠️ **This is the *outset* form, which is clipped inside a scroll container** (BUG-086, noted
    // 2026-09-28). A button rendered in a box with `overflow` needs `focus-visible:ring-inset` in
    // place of the two offset classes — §4 *Focus* states the exception at the rule's site. It
    // **replaces** them rather than being added to them: `ring-inset` and `ring-offset-*` are not one
    // `tailwind-merge` group, so a caller that passes only `ring-inset` keeps the offset it meant to
    // drop. No button ships that way today; the note is here because this string is what the next one
    // is copied from, which is the whole of BUG-086.
    'outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-paper-bg',
  ),
  {
    variants: {
      variant: {
        primary: 'bg-accent text-accent-fg hover:bg-accent/90',
        secondary: 'border border-rule-control bg-paper text-ink-900 hover:bg-paper-sunken',
        ghost: 'text-ink-700 hover:bg-paper-sunken',
        danger: 'border border-negative text-negative hover:bg-negative-wash',
      },
      size: {
        sm: 'h-8 px-3 text-xs',
        md: 'h-9 px-4 text-sm',
      },
    },
    defaultVariants: { variant: 'secondary', size: 'md' },
  },
);
